export default {"src":"/_next/static/image/public/images/aster_secure_responsive.3779d6d409b6da0579294ef9dfeb74c6.svg","height":215,"width":380};